import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import "rxjs/add/operator/map";
import { Observable } from "rxjs/Observable";
import { Storage } from '../../browser-storage';
import { TmMenu } from '../model/menu';
import { ApiBase } from './apibase.service';



export class Menu extends ApiBase {

    constructor(protected http: Http) {
        super(http);
    }

    get(): Observable<TmMenu[]> {
        let storage = new Storage();
        let menu = storage.getSessionMenu();
      
        if (menu != null) {
            return Observable.of(menu)
                .map(menu => menu);
        } else {
            return this.http
                .get(this.baseUrl + "/menu", { headers: this.cachebleHeaders })
                .map(r => r.json() as TmMenu[])
                .flatMap(menu => {
                    storage.setSessionMenu(menu);
                    return Observable.of(menu)
                        .map(menu => menu);
                });
        }
    }
}(Menu as any).ctorParameters = function () { return [ { type: Http } ]; }


// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../tscapi/service/menu.service.ts